import classNames from 'classnames';
import { useCallback } from 'react';

import { GridItem, ToggleCard } from '@farmersdog/corgi-x';

import { bowlPictureSources } from '../../../images/RecipeBowlPicture/assets';
import styles from '../RecipesSelection.module.css';

import type { PetRecipesQuery } from '../../../../graphql/types';

export const RecipeCard = ({
  recipe,
  onChangeSelection,
  currentPetRecipeSelection,
  onClickSeeDetails,
  badgeCopy,
}: {
  recipe: PetRecipesQuery['petRecipes'][number];
  onChangeSelection?: (recipe: string) => void;
  currentPetRecipeSelection: string[];
  onClickSeeDetails: (recipe: string) => void;
  badgeCopy?: string;
}) => {
  const checked = currentPetRecipeSelection.includes(recipe.name);
  const disabledAndNotSelected = !onChangeSelection && !checked;

  const handleChangeSelection = useCallback(() => {
    if (onChangeSelection) {
      onChangeSelection(recipe.name);
    }
  }, [onChangeSelection, recipe.name]);

  const handleClickSeeDetails = useCallback(() => {
    onClickSeeDetails(recipe.name);
  }, [onClickSeeDetails, recipe.name]);

  return (
    <GridItem
      xl={12}
      md={3}
      xs={6}
      key={recipe.name}
      className={styles.recipeToggleCard}
      alignItems="stretch"
      growContent
    >
      <ToggleCard
        className={classNames({
          [styles.recipeToggleCardCannotAdd]: disabledAndNotSelected,
        })}
        heading={recipe.content.displayName}
        description={recipe.content.mainIngredients}
        imageSources={bowlPictureSources[recipe.name]}
        imageAlt={`bowl of ${recipe.content.displayName} recipe food`}
        badge={badgeCopy}
        label={disabledAndNotSelected ? 'Cannot Add' : 'Add'}
        checkedLabel={'Added'}
        onChange={handleChangeSelection}
        checked={checked}
        value={recipe.name}
        buttonLabel={'See Details'}
        buttonProps={{
          className: styles.detailsButton,
          type: 'button',
          disabled: disabledAndNotSelected,
        }}
        onButtonClick={handleClickSeeDetails}
        contentClassName={styles.contentContainer}
        controlClassName={styles.controlContainer}
        checkboxProps={{
          disabled: !onChangeSelection,
        }}
      />
    </GridItem>
  );
};
